import React from "react";
import SelectApiInput, { ISelectApiInput } from "../../input/SelectApiInput";

interface IFilterSelectApi extends ISelectApiInput {}

function FilterSelectApi({ ...props }: IFilterSelectApi) {
  return <SelectApiInput labelWidth="25%" direction="column" {...props} />;
}

export default FilterSelectApi;
